// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:host {
  display: flex;
  flex-direction: column;
}

.add-btn {
  height: 100px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}
.add-btn button {
  height: 50px;
}

.list-container {
  height: 100%;
  overflow: auto;
}
.list-container table {
  width: 100%;
  border: 1px solid #e7e7e7;
}
.list-container table tr {
  height: 50px;
}
.list-container table .mat-header-row {
  background-color: #ffffff;
}
.list-container table .mat-row {
  border: 1px solid #e7e7e7;
}
.list-container table .mat-row:nth-child(odd) {
  background-color: #f6f6f6;
}
.list-container table .name,
.list-container table .desc {
  width: 250px;
}
.list-container table .edit {
  text-align: center;
  width: 50px;
  cursor: pointer;
}
.list-container table .mat-cell,
.list-container table .mat-header-cell {
  padding-left: 20px;
}
.list-container table .mat-cell:nth-child(1),
.list-container table .mat-header-cell:nth-child(1) {
  width: 50px;
}
.list-container table .letter {
  display: inline-block;
}
.list-container table .letter::before {
  content: " ";
}
.list-container table .letter::after {
  content: ",";
}
.list-container table .letter:last-child::after {
  content: "";
}

mat-form-field {
  width: 100%;
  padding: 0 20px;
}

.list-container-small {
  max-height: 300px;
  overflow: auto;
}
.list-container-small table {
  width: 100%;
  border: 1px solid #e7e7e7;
}
.list-container-small table tr {
  height: 50px;
}
.list-container-small table .mat-header-row {
  background-color: #ffffff;
}
.list-container-small table .mat-row {
  border: 1px solid #e7e7e7;
}
.list-container-small table .mat-row:nth-child(odd) {
  background-color: #f6f6f6;
}
.list-container-small table .name,
.list-container-small table .desc {
  width: 250px;
}
.list-container-small table .edit {
  text-align: center;
  width: 50px;
  cursor: pointer;
}
.list-container-small table .mat-cell,
.list-container-small table .mat-header-cell {
  padding-left: 20px;
}
.list-container-small table .mat-cell:nth-child(1),
.list-container-small table .mat-header-cell:nth-child(1) {
  width: 50px;
}
.list-container-small table .letter {
  display: inline-block;
}
.list-container-small table .letter::before {
  content: " ";
}
.list-container-small table .letter::after {
  content: ",";
}
.list-container-small table .letter:last-child::after {
  content: "";
}

:host {
  position: relative;
}

button {
  display: flex;
  justify-content: center;
  align-items: center;
}

.table-wrapper {
  overflow: auto;
  height: 200px;
}

table {
  width: 100%;
}
table .mat-column-number {
  text-align: center;
}
table td,
table th {
  padding: 10px;
}
table .name {
  width: 30%;
}
table .number {
  width: 10%;
  text-align: center;
}
table .extend {
  cursor: pointer;
}

.calendar {
  position: absolute;
  top: 0;
  left: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/mio/mio.component.scss","webpack://./src/app/shared/list.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;EACE,aAAA;EACA,sBAAA;ADEF;;ACCA;EACE,aAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;ADEF;ACAE;EACE,YAAA;ADEJ;;ACEA;EACE,YAAA;EACA,cAAA;ADCF;ACEE;EACE,WAAA;EACA,yBAAA;ADAJ;ACEI;EACE,YAAA;ADAN;ACGI;EACE,yBAAA;ADDN;ACII;EACE,yBAAA;ADFN;ACIM;EACE,yBAAA;ADFR;ACMI;;EAEE,YAAA;ADJN;ACOI;EACE,kBAAA;EACA,WAAA;EACA,eAAA;ADLN;ACQI;;EAEE,kBAAA;ADNN;ACQM;;EACE,WAAA;ADLR;ACSI;EACE,qBAAA;ADPN;ACSM;EACE,YAAA;ADPR;ACUM;EACE,YAAA;ADRR;ACYQ;EACE,WAAA;ADVV;;ACiBA;EACE,WAAA;EACA,eAAA;ADdF;;ACiBA;EACE,iBAAA;EACA,cAAA;ADdF;ACiBE;EACE,WAAA;EACA,yBAAA;ADfJ;ACiBI;EACE,YAAA;ADfN;ACkBI;EACE,yBAAA;ADhBN;ACmBI;EACE,yBAAA;ADjBN;ACmBM;EACE,yBAAA;ADjBR;ACqBI;;EAEE,YAAA;ADnBN;ACsBI;EACE,kBAAA;EACA,WAAA;EACA,eAAA;ADpBN;ACuBI;;EAEE,kBAAA;ADrBN;ACuBM;;EACE,WAAA;ADpBR;ACwBI;EACE,qBAAA;ADtBN;ACwBM;EACE,YAAA;ADtBR;ACyBM;EACE,YAAA;ADvBR;AC2BQ;EACE,WAAA;ADzBV;;AAvHA;EACI,kBAAA;AA0HJ;;AAvHA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AA0HJ;;AAvHA;EACI,cAAA;EACA,aAAA;AA0HJ;;AAvHA;EACI,WAAA;AA0HJ;AAzHI;EACI,kBAAA;AA2HR;AAzHI;;EAEI,aAAA;AA2HR;AAzHI;EACI,UAAA;AA2HR;AAzHI;EACI,UAAA;EACA,kBAAA;AA2HR;AAzHI;EACI,eAAA;AA2HR;;AAvHA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;AA0HJ","sourcesContent":["@import '../../shared/list';\r\n:host {\r\n    position: relative;\r\n}\r\n\r\nbutton {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.table-wrapper {\r\n    overflow: auto;\r\n    height: 200px;\r\n}\r\n\r\ntable {\r\n    width: 100%;\r\n    .mat-column-number {\r\n        text-align: center;\r\n    }\r\n    td,\r\n    th {\r\n        padding: 10px;\r\n    }\r\n    .name {\r\n        width: 30%;\r\n    }\r\n    .number {\r\n        width: 10%;\r\n        text-align: center;\r\n    }\r\n    .extend {\r\n        cursor: pointer;\r\n    }\r\n}\r\n\r\n.calendar {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n}",":host {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.add-btn {\r\n  height: 100px;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 0 20px;\r\n\r\n  button {\r\n    height: 50px;\r\n  }\r\n}\r\n\r\n.list-container {\r\n  height: 100%;\r\n  overflow: auto;\r\n  // border: 1px solid #e7e7e7;\r\n\r\n  table {\r\n    width: 100%;\r\n    border: 1px solid #e7e7e7;\r\n\r\n    tr {\r\n      height: 50px;\r\n    }\r\n\r\n    .mat-header-row {\r\n      background-color: #ffffff;\r\n    }\r\n\r\n    .mat-row {\r\n      border: 1px solid #e7e7e7;\r\n\r\n      &:nth-child(odd) {\r\n        background-color: #f6f6f6;\r\n      }\r\n    }\r\n\r\n    .name,\r\n    .desc {\r\n      width: 250px;\r\n    }\r\n\r\n    .edit {\r\n      text-align: center;\r\n      width: 50px;\r\n      cursor: pointer;\r\n    }\r\n\r\n    .mat-cell,\r\n    .mat-header-cell {\r\n      padding-left: 20px;\r\n\r\n      &:nth-child(1) {\r\n        width: 50px;\r\n      }\r\n    }\r\n\r\n    .letter {\r\n      display: inline-block;\r\n\r\n      &::before {\r\n        content: '\\00a0'\r\n      }\r\n\r\n      &::after {\r\n        content: ','\r\n      }\r\n\r\n      &:last-child {\r\n        &::after {\r\n          content: ''\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\nmat-form-field {\r\n  width: 100%;\r\n  padding: 0 20px;\r\n}\r\n\r\n.list-container-small {\r\n  max-height: 300px;\r\n  overflow: auto;\r\n  // border: 1px solid #e7e7e7;\r\n\r\n  table {\r\n    width: 100%;\r\n    border: 1px solid #e7e7e7;\r\n\r\n    tr {\r\n      height: 50px;\r\n    }\r\n\r\n    .mat-header-row {\r\n      background-color: #ffffff;\r\n    }\r\n\r\n    .mat-row {\r\n      border: 1px solid #e7e7e7;\r\n\r\n      &:nth-child(odd) {\r\n        background-color: #f6f6f6;\r\n      }\r\n    }\r\n\r\n    .name,\r\n    .desc {\r\n      width: 250px;\r\n    }\r\n\r\n    .edit {\r\n      text-align: center;\r\n      width: 50px;\r\n      cursor: pointer;\r\n    }\r\n\r\n    .mat-cell,\r\n    .mat-header-cell {\r\n      padding-left: 20px;\r\n\r\n      &:nth-child(1) {\r\n        width: 50px;\r\n      }\r\n    }\r\n\r\n    .letter {\r\n      display: inline-block;\r\n\r\n      &::before {\r\n        content: '\\00a0'\r\n      }\r\n\r\n      &::after {\r\n        content: ','\r\n      }\r\n\r\n      &:last-child {\r\n        &::after {\r\n          content: ''\r\n        }\r\n      }\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
